import { api } from "../api";
import {
  GameDiagnosticFull,
  GameDiagnosticListResponse,
  GameDiagnosticSummary,
} from "./game-diagnostics.types";

export const getGameDiagnostics = async (params?: {
  game_url?: string;
  platform?: string;
  user_id?: number;
  limit?: number;
  offset?: number;
}): Promise<GameDiagnosticListResponse> => {
  try {
    const response = await api.get("/game-diagnostics", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching game diagnostics:", error);
    return { data: [], total: 0 };
  }
};

export const getGameDiagnosticById = async (
  id: number
): Promise<GameDiagnosticFull | null> => {
  try {
    const response = await api.get(`/game-diagnostics/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching game diagnostic:", error);
    return null;
  }
};

export const getGameDiagnosticSummary = async (
  game_url?: string
): Promise<GameDiagnosticSummary | null> => {
  try {
    const response = await api.get("/game-diagnostics/summary", {
      params: game_url ? { game_url } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching game diagnostic summary:", error);
    return null;
  }
};

export const getGameDiagnosticsByUser = async (
  userId: number,
  limit?: number
): Promise<GameDiagnosticFull[]> => {
  try {
    const response = await api.get(`/game-diagnostics/user/${userId}`, {
      params: limit ? { limit } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user game diagnostics:", error);
    return [];
  }
};
